// The shop's public name and branch, remembered from the last
// GET /business-information/public. The store starts from it, so the sign-in page
// shows this shop's name at first paint instead of flashing VITE_APP_TITLE until
// the API answers. Each shop has its own site, so each keeps its own copy.

const SHOP_KEY = 'pos_shop_identity';

export const readRememberedShop = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(SHOP_KEY) || 'null');
    return saved && typeof saved.BusinessName === 'string' ? saved : null;
  } catch {
    return null;
  }
};

export const rememberShop = (info) => {
  if (!info?.BusinessName) return;
  try {
    localStorage.setItem(
      SHOP_KEY,
      JSON.stringify({
        BusinessName: info.BusinessName,
        BranchLocation: info.BranchLocation || null,
      }),
    );
  } catch {
    // Storage blocked: the page falls back to VITE_APP_TITLE until the API answers.
  }
};
